import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon, FlagIcon, BookOpenIcon, ActivityIcon, CheckCircleIcon } from 'lucide-react';
export function Hero() {
  const features = [{
    icon: <FileTextIcon className="w-3 h-3" data-id="element-112" />,
    text: '100% PDF'
  }, {
    icon: <ZapIcon className="w-3 h-3" data-id="element-113" />,
    text: 'Acceso en 5 min'
  }, {
    icon: <FlagIcon className="w-3 h-3" data-id="element-114" />,
    text: 'Hecho para Argentina'
  }, {
    icon: <BookOpenIcon className="w-3 h-3" data-id="element-115" />,
    text: '6 Tomos completos'
  }, {
    icon: <ActivityIcon className="w-3 h-3" data-id="element-116" />,
    text: 'De cero a vender'
  }, {
    icon: <CheckCircleIcon className="w-3 h-3" data-id="element-117" />,
    text: '3 Bonos incluidos'
  }];
  const stats = ['+500 emprendedoras confían', '6 Tomos listos', '3 Bonos incluidos', '4,9/5 ⭐'];
  return <section className="w-full bg-neutral-950 py-4 md:py-10" data-id="element-118">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-119">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-120">
          <div className="mb-1" data-id="element-121">
            <span className="text-amber-400 font-bold text-sm tracking-wider" data-id="element-122">
              🕯️ RECURSOHUB™
            </span>
          </div>

          <h1 className="md:text-6xl lg:text-7xl text-amber-50 mb-0.5 md:mb-1 text-[28px] font-[700] leading-tight" data-id="element-123">
            Aprendé a hacer Velas Comestibles Gourmet y convertilas en un
            negocio real desde casa
          </h1>

          <h2 className="md:text-5xl lg:text-6xl text-amber-400 mb-2 md:mb-3 text-[14px] font-[600] font-[Avenir,_sans-serif] leading-snug" data-id="element-124">
            La tendencia gastronómica que está explotando en Argentina — y que
            todavía podés aprovechar antes que todos. Sin local, sin empleados,
            desde tu cocina.
          </h2>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.3,
          duration: 0.7
        }} className="mb-3 md:mb-5" data-id="element-125">
            <img src="https://cdn.magicpatterns.com/uploads/8Qx36xJDRZca3dqTgwLkiw/donas_(3).png" alt="Mega Pack Velas Comestibles Gourmet — 6 Tomos + 3 Bonos" className="max-w-md md:max-w-lg lg:max-w-2xl mx-auto w-full h-auto" data-id="element-126" />
          </motion.div>

          <div className="mb-1 md:mb-3" data-id="element-127">
            <p className="md:text-lg text-amber-400 font-medium text-[14px]" data-id="element-128">
              El sistema completo para aprender, crear y vender velas
              comestibles gourmet en Argentina
            </p>
          </div>

          <p className="md:text-lg text-neutral-300 mb-3 md:mb-5 max-w-3xl mx-auto text-[14px]" data-id="element-129"></p>

          <div className="flex flex-wrap justify-center gap-1.5 mb-3 md:mb-5" data-id="element-130">
            {features.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: index * 0.1,
            duration: 0.3
          }} className="flex items-center gap-1 bg-neutral-900 border border-amber-900/50 rounded-full px-2.5 py-1" data-id="element-131">
                <span className="text-amber-400" data-id="element-132">{feature.icon}</span>
                <span className="text-xs text-neutral-300 font-medium" data-id="element-133">
                  {feature.text}
                </span>
              </motion.div>)}
          </div>

          <motion.a href="#elegi-tu-pack" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-gradient-to-r from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-neutral-950 font-bold text-lg md:text-xl px-8 md:px-12 py-4 md:py-5 rounded-lg mb-2 md:mb-3 transition-colors shadow-[0_0_30px_rgba(251,191,36,0.25)] cursor-pointer" data-id="element-134">
            🔴 ¡QUIERO EMPEZAR MI EMPRENDIMIENTO HOY!
          </motion.a>

          <p className="text-sm text-neutral-400 mb-3 md:mb-6" data-id="element-135">
            📩Acceso inmediato por Mail | 🎁50% OFF Solo por Hoy
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3 max-w-3xl mx-auto" data-id="element-136">
            {stats.map((stat, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.8 + index * 0.1,
            duration: 0.4
          }} className="bg-neutral-900 border border-amber-900/40 rounded-lg p-2 md:p-3" data-id="element-137">
                <p className="text-sm md:text-base font-semibold text-amber-50" data-id="element-138">
                  {stat}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}